import { fetchWithAuth } from './api';

const host = window.location.hostname === 'localhost' ? "http://localhost:8000/api" : "/api";

export interface Notification {
  notification_id: number;
  user_id: number;
  message: string;
  severity: string;
  status: string;
  contract_id: number | null;
  created_at: string;
  updated_at: string;
}

/**
 * Get all notifications for the current user
 * @returns Array of notifications
 */
export const getNotifications = async (): Promise<Notification[]> => {
  const response = await fetchWithAuth(
    host + '/notifications/',
    {
      method: 'GET'
    }
  );
  
  if (!response.ok) {
    throw new Error('Failed to fetch notifications');
  }
  
  return await response.json();
};

/**
 * Mark a notification as read
 * @param notificationId ID of the notification to mark as read
 */
export const markNotificationAsRead = async (notificationId: number): Promise<void> => {
  const response = await fetchWithAuth(
    host + `/notifications/${notificationId}/read`,
    {
      method: 'PUT'
    }
  );
  
  if (!response.ok) {
    throw new Error('Failed to mark notification as read');
  }
};

/**
 * Mark all notifications as read
 */
export const markAllNotificationsAsRead = async (): Promise<void> => {
  const response = await fetchWithAuth(
    host + '/notifications/read-all',
    {
      method: 'PUT'
    }
  );
  
  if (!response.ok) {
    throw new Error('Failed to mark all notifications as read');
  }
};

/**
 * Delete a notification
 * @param notificationId ID of the notification to delete
 */
export const deleteNotification = async (notificationId: number): Promise<void> => {
  const response = await fetchWithAuth(
    host + `/notifications/${notificationId}`,
    {
      method: 'DELETE'
    }
  );
  
  if (!response.ok) {
    throw new Error('Failed to delete notification');
  }
};
